import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Signed storage upload URLs authenticate through their query string.
    let isStudioHost = false;
    try {
      isStudioHost = new URL(request.url).hostname === 'studio.seekxr.com';
    } catch {
      isStudioHost = false;
    }

    if (request.url.includes('s3') || request.url.startsWith('https://storage.googleapis.com/')
      || request.url.startsWith('/gcs-upload') || isStudioHost
      || request.url.includes('queue-') || request.url.includes('newrelic.com')) {
      return next.handle(request);
    }

    const token = localStorage.getItem('authToken');
    if (token) {
      return next.handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
    } else {
      return next.handle(request);
    }
  }
}
